// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Fz-z","tooltipWrapper":"Gz-z","icon":"Hz-z","tooltip":"Iz-z","content":"Jz-z"};